<template>
  <div>
    <div>
      <ul class="account__logo">
        <li v-if="clientData.logos && clientData.logos.medium">
          <img :src="clientData.logos.medium" />
          <span class="img-container"></span>
          <gl-button round icon-center="glicon-trash" @onClick.prevent="deleteLogo"></gl-button>
        </li>
        <li v-else class="account__logo--placeholder">
          <span class="glicon-px-image"></span>
        </li>
        <li>
          <a
            v-profile-guard="'components.dataAccount.edit.editAccountLogo'"
            @click="openPopUp = true"
            >{{ $t(`account.edit.logo`) }}</a
          >
          <div
            v-profile-guard="'components.dataAccount.edit.editCampusLogo'"
            class="checkbox small-check"
          >
            <gl-checkbox
              id="account.isShowedCampus"
              v-model="form.isShowedCampus"
              v-skeletor:onChange="setValue"
              :label="$t(`account.edit.logoActions.showInCampus`)"
              :checked="form.isShowedCampus"
              :small="true"
            >
            </gl-checkbox>
          </div>
        </li>
      </ul>
    </div>
    <PopUpLogo
      v-if="openPopUp"
      :size-in-mb="5"
      @update-logo="(data) => $emit('update-logo', data)"
      @close="openPopUp = $event"
    ></PopUpLogo>
  </div>
</template>

<script>
import PopUpLogo from '../PopUps/PopUpLogo';
import { formatIds } from '../../../utils/functions.js';

export default {
  name: 'CardLogo',
  components: {
    PopUpLogo
  },
  props: {
    clientData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        isShowedCampus: null
      },
      openPopUp: false
    };
  },
  created() {
    this.form.isShowedCampus = this.clientData.showDistributorLogo;
  },

  methods: {
    setValue(field, value) {
      this.setForm(formatIds(field), value);
      this.campusLogoStatus();
    },
    setForm(attr, value) {
      this.$set(this.form, attr, value);
    },
    fieldToEdit(event) {
      this.$emit('fieldToEdit', event);
    },
    async campusLogoStatus() {
      let data = {
        showDistributorLogo: this.form.isShowedCampus
      };
      let updateData = {
        body: data,
        notification: {
          type: 'success',
          message: `feedback.success.logo.${this.form.isShowedCampus}`,
          fieldToEdit: this.fieldToEdit,
          show: true
        }
      };
      await this.$store.dispatch('updateDistributor', updateData);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    deleteLogo() {
      const data = {
        body: {
          logo: null
        },
        notification: {
          type: 'success',
          message: `feedback.success.changeLogo`,
          show: true
        }
      };
      this.$emit('update-logo', data);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>
